"use client"
import { FaDiscord, FaTiktok, FaInstagram, FaYoutube, FaWhatsapp } from "react-icons/fa6"
import { FiPhone, FiMail, FiMapPin } from "react-icons/fi"
import Image from "next/image"
import { useTranslations } from "next-intl"

const Footer = () => {
  const t = useTranslations('Footer')
  return (
    <>

      <footer className="relative z-10 w-full bg-black overflow-hidden">
        <div
          className="absolute top-0 inset-x-0 h-[1px] w-full mask-x-from-50%"
          style={{ backgroundColor: "#6d17b34d" }}
        ></div>
        <div
          className="pointer-events-none absolute inset-0"
          style={{
            backgroundImage: "radial-gradient(ellipse at 50% 100%, #7c44e530 0%, transparent 60%)",
          }}
        />
        <div className="max-w-7xl mx-auto px-6 pt-24 pb-12 relative">
          <div className="flex flex-col lg:flex-row justify-between gap-20">
            <div className="flex flex-col gap-6 max-w-sm">
              <div className="flex items-center gap-3">
                <Image className="w-14 h-auto" src="https://cdn.aurex.lk/assets/image.webp" alt="Aurex Logo" width={56} height={56} style={{ height: "auto" }} />
                <span className="font-akira text-white text-3xl tracking-wide">AUREX</span>
              </div>
              <p className="text-gray-500 font-poppins text-base leading-relaxed">
                {t('desc')}
              </p>
              <div className="flex flex-col gap-2">
                <span className="text-white/30 font-poppins text-xs uppercase tracking-widest">{t('follow')}</span>
                <div className="flex items-center gap-5">
                  <a href="https://discord.com/invite/aurex" target="_blank" rel="noopener noreferrer" aria-label="Discord" className="text-gray-500 hover:text-[#5865F2] transition-colors duration-200">
                    <FaDiscord size={26} />
                  </a>
                  <a href="https://www.tiktok.com/@aurex.lk" target="_blank" rel="noopener noreferrer" aria-label="TikTok" className="text-gray-500 hover:text-white transition-colors duration-200">
                    <FaTiktok size={26} />
                  </a>
                  <a href="https://www.instagram.com/aurex.lk" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="text-gray-500 hover:text-pink-500 transition-colors duration-200">
                    <FaInstagram size={26} />
                  </a>
                  <a href="https://www.youtube.com/@aurexhosting" target="_blank" rel="noopener noreferrer" aria-label="YouTube" className="text-gray-500 hover:text-red-500 transition-colors duration-200">
                    <FaYoutube size={26} />
                  </a>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8 lg:gap-8 w-full">
              <div className="flex flex-col gap-5">
                <span className="text-white font-akira text-base tracking-wider">{t('services')}</span>
                <div className="flex flex-col gap-4">
                  <a href="/minecraft-servers" className="text-gray-500 hover:text-white font-poppins text-base transition-colors duration-200">{t('mc_servers')}</a>
                  <a href="/hytale-servers" className="text-gray-500 hover:text-white font-poppins text-base transition-colors duration-200">{t('hytale_servers')}</a>
                  <a href="/coming-soon" className="text-gray-500 hover:text-white font-poppins text-base transition-colors duration-200">{t('vps')}</a>
                  <a href="/coming-soon" className="text-gray-500 hover:text-white font-poppins text-base transition-colors duration-200">{t('dedicated')}</a>
                </div>
              </div>
              <div className="flex flex-col gap-5">
                <span className="text-white font-akira text-base tracking-wider">{t('company')}</span>
                <div className="flex flex-col gap-4">
                  <a href="/about-us" className="text-gray-500 hover:text-white font-poppins text-base transition-colors duration-200">{t('about')}</a>
                  <a href="/game-panel" className="text-gray-500 hover:text-white font-poppins text-base transition-colors duration-200">{t('spark_panel')}</a>
                  <a href="/hardware" className="text-gray-500 hover:text-white font-poppins text-base transition-colors duration-200">{t('hardware_locations')}</a>
                  <a href="/contact-us" className="text-gray-500 hover:text-white font-poppins text-base transition-colors duration-200">{t('contact_us')}</a>
                  <a href="https://dash.aurex.lk/login" className="text-gray-500 hover:text-white font-poppins text-base transition-colors duration-200">{t('marketplace')}</a>
                  <a href="https://dash.aurex.lk/blog" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-white font-poppins text-base transition-colors duration-200">{t('blog')}</a>
                </div>
              </div>
              <div className="flex flex-col gap-5">
                <span className="text-white font-akira text-base tracking-wider">{t('support')}</span>
                <div className="flex flex-col gap-4">
                  <a href="https://discord.com/invite/aurex" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-white font-poppins text-base transition-colors duration-200">{t('help_center')}</a>
                  <a href="https://status.aurex.lk/" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-white font-poppins text-base transition-colors duration-200">{t('status')}</a>
                  <a href="https://dash.aurex.lk/tickets" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-white font-poppins text-base transition-colors duration-200">{t('ticket')}</a>
                  <a href="https://discord.com/channels/1156974653236068354/1508633423999271034" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-white font-poppins text-base transition-colors duration-200">{t('discord_support')}</a>
                </div>
              </div>
              <div className="flex flex-col gap-5">
                <span className="text-white font-akira text-base tracking-wider">{t('legal')}</span>
                <div className="flex flex-col gap-4">
                  <a href="/privacy" className="text-gray-500 hover:text-white font-poppins text-base transition-colors duration-200">{t('privacy')}</a>
                  <a href="/tos" className="text-gray-500 hover:text-white font-poppins text-base transition-colors duration-200">{t('tos')}</a>
                  <a href="/cookie-policy" className="text-gray-500 hover:text-white font-poppins text-base transition-colors duration-200">{t('cookie')}</a>
                  <a href="/refund-policy" className="text-gray-500 hover:text-white font-poppins text-base transition-colors duration-200">{t('refund')}</a>
                </div>
              </div>
              <div className="flex flex-col gap-5 col-span-2 md:col-span-1">
                <span className="text-white font-akira text-base tracking-wider">{t('contact')}</span>
                <div className="flex flex-col gap-4">
                  <a href="tel:0770030855" aria-label="Call 0770030855" className="group flex items-center gap-2 text-gray-500 hover:text-white font-poppins text-sm transition-colors duration-200">
                    <FiPhone className="h-4 w-4 shrink-0 text-purple-400/80 group-hover:text-purple-300 transition-colors" />
                    <span>+94770030855</span>
                  </a>
                  <a href="https://wa.me/94766360600" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp +94 76 636 0600" className="group flex items-center gap-2 text-gray-500 hover:text-white font-poppins text-sm transition-colors duration-200">
                    <FaWhatsapp className="h-4 w-4 shrink-0 text-purple-400/80 group-hover:text-purple-300 transition-colors" />
                    <span>+94766360600</span>
                  </a>
                  <a href="mailto:contact@aurex.lk" aria-label="Email contact@aurex.lk" className="group flex items-center gap-2 text-gray-500 hover:text-white font-poppins text-sm transition-colors duration-200">
                    <FiMail className="h-4 w-4 shrink-0 text-purple-400/80 group-hover:text-purple-300 transition-colors" />
                    <span>contact@aurex.lk</span>
                  </a>
                  <a href="https://maps.google.com/?q=404+Maithridasa+Mawatha,+Pitipana+North,+Pitipana,+Homagama" target="_blank" rel="noopener noreferrer" aria-label="View address on Google Maps" className="group flex items-start gap-2 text-gray-500 hover:text-white font-poppins text-sm transition-colors duration-200">
                    <FiMapPin className="h-4 w-4 shrink-0 mt-0.5 text-purple-400/80 group-hover:text-purple-300 transition-colors" />
                    <span className="leading-snug">404 Maithridasa<br />Mawatha, Pitipana<br />North, Homagama</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-20 pt-6 border-t border-white/5 flex flex-col items-center justify-center gap-3">
            <p className="text-gray-600 font-poppins text-sm text-center">{t('rights', { year: new Date().getFullYear() })}</p>
          </div>
        </div>
      </footer>
    </>
  )
}

export default Footer
